/* ============
 * Vue Instant!
 * ============
 *
 * Vue instant allows you to easily create custom search controls with auto suggestions
 * for your vue 2 applications.
 *
 * https://santiblanko.github.io/vue-instant/#/
 */

import 'vue-instant/dist/vue-instant.css';



// WEBPACK FOOTER //
// ./src/plugins/vue-instant.js